export default __webpack_public_path__ + "static/media/upee_with_b.899b7a5f.webp";